import { CustomColumnSettingsRealTimeData } from 'src/generated/signalR/custom-column-settings-real-time-data';

export class CustomColumnSettingsUpdated {
   public static readonly type = '[CustomColumnSettings] Updated';

   constructor(public data: CustomColumnSettingsRealTimeData) {}
}
